import { IResource, TResourceConfiguration } from '../core/resource';
import { IPlugin, IExtensible } from '../resources/plugin';
import { IView } from '../resources/view';

import ess from'../../../pip/library/pi-ess/pi-ess.js';
import $ip from'../../../pip/library/pi-ip/pi-ip.js';
import f1 from'../../../pip/library/pi-f1/pi-f1.js';

const site = 'ignition';

/**
 *
 */
export class Ignition {
  private static readonly __self: Ignition = new Ignition();

  /**
   * creates singleton instance of Ignition
   */
  static make() {
    return Ignition.__self;
  }
  /**
   *
   */
  attach(plugin: IPlugin, extensible: IExtensible) {
    return f1
      .serial(
        [
          () => ess.tap(plugin, { site, action: 'attach' }),
          () => (plugin.attach ? plugin.attach(extensible) : f1.done(plugin)),
          () => ess.tap(plugin, { site, action: 'attachPlugin' }),
          () => (extensible.attachPlugin ? extensible.attachPlugin(plugin).then(() => plugin) : f1.done(plugin))
        ],
        this
      )
      .then(() => plugin);
  }

  /**
   *
   */
  detach(plugin: IPlugin, extensible: IExtensible) {
    return f1
      .serial(
        [
          () => ess.tap(plugin, { site, action: 'detachPlugin' }),
          () => (extensible.detachPlugin ? extensible.detachPlugin(plugin).then(() => plugin) : f1.done(plugin)),
          () => ess.tap(plugin, { site, action: 'detach' }),
          () => (plugin.detach ? plugin.detach(extensible) : f1.done(plugin))
        ],
        this
      )
      .then(() => plugin);
  }

  /**
   * a view should run through the startup process before being mounted
   */
  mount(view: IView, region: HTMLElement) {
    return f1
      .serial(
        [
          () => ess.tap(view, { site, action: 'dock-in-region' }),
          () => this.__dockInRegion(view, region),
          () => ess.tap(view, { site, action: 'mount' }),
          () => (view.mount ? view.mount(region) : f1.done(view))
        ],
        this
      )
      .then(() => view);
  }

  private __dockInRegion(view: IView, region: HTMLElement) {
    view.region = region;
    return f1.done(view);
  }

  unmount(view: IView) {
    return f1
      .serial(
        [() => ess.tap(view, { site, action: 'unmount' }), () => (view.unmount ? view.unmount() : f1.done(view))],
        this
      )
      .then(() => view);
  }

  startup(resource: IResource, configuration: TResourceConfiguration) {
    return f1
      .serial(
        [
          () => ess.tap(resource, { site, action: 'import-resources' }),
          () => this.__import(resource, configuration),
          () => ess.tap(resource, { site, action: 'initialize' }),
          () => (resource.initialize ? resource.initialize(configuration, resource.resources) : f1.done(resource)),
          () => ess.tap(resource, { site, action: 'activate' }),
          () => (resource.activate ? resource.activate() : f1.done(resource))
        ],
        this
      )
      .then(() => resource);
  }

  private __import(resource: IResource, configuration: TResourceConfiguration): Promise<IResource> {
    if (!resource.imports) {
      return Promise.resolve(resource);
    }

    return $ip.requires(resource.imports || []).then((resources) => {
      resource.resources = resources;
      return Promise.all(f1.map((resource: IResource) => this.startup(resource, configuration), resources)).then(() => {
        return resource;
      });
    });
  }

  shutdown(resource: IResource) {
    return f1
      .serial(
        [
          () => ess.tap(resource, { site, action: 'deactivate' }),
          () => (resource.deactivate ? resource.deactivate() : f1.done(resource)),
          () => ess.tap(resource, { site, action: 'uninitialize' }),
          () => (resource.uninitialize ? resource.uninitialize() : f1.done(resource)),
          () => ess.tap(resource, { site, action: 'unimport-resources' }),
          () => this.__unImport(resource)
        ],
        this
      )
      .then(() => resource);
  }

  private __unImport(resource: IResource): Promise<IResource> {
    if (!resource.imports) {
      return Promise.resolve(resource);
    }

    return Promise.all(f1.map((resource: IResource) => this.shutdown(resource), resource.resources || []))
      .then(() => {
        return $ip.destroy(resource.resources || []);
      })
      .then(() => resource);
  }
}
